import { LoadingOutlined } from "@ant-design/icons";
import React from "react";

export default function Loading({
  background,
}) {
  return <div className="loading-container" style={{ background }}>
    <div className="loader">
      <LoadingOutlined />
    </div>
  </div>;
}
